// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Q54Wp","header":"PatientBlock_header__2dqQo","label":"PatientBlock_label__1X50L","option":"PatientBlock_option__358gr"};